import Dashboard from "@/layouts/Dashboard.vue";
import NotificationsList from "@/components/Notifications/NotificationsList.vue";

const NotificationRoutes = [
    {
        path: "/notification",
        redirect: "/notification/list",
        components: {
            page: NotificationsList
        },
        children: [
            {
                path: "list",
                name: "NotificationList",
                components: 
                {
                    // ... 
                    // page: () => import("@/components/Notifications/NotificationsList.vue")
                
                }
            }
        ]
    }
];

export default NotificationRoutes;
